<template lang="pug">
  form(@submit.prevent="navigate('sistema.docModelos.edit.confirmar')")
    p.text-large - Textos do Modelo
    .columns
      .column.col-12
        doc-textos(v-model="$v.resource.textos.$model" group="textos" editable)
    .pt-2
      .divider
      button.btn.btn-primary(:disabled="$v.resource.$invalid")
        btn-content(name="next")
</template>

<script>
import DocTexto from '@/models/DocTexto'
import editMixin from './mixin'

export default {
  mixins: [editMixin],
  validations: {
    resource: {
      textos: {
        $each: DocTexto.validations,
      },
    },
  },
}
</script>
